<div class="row">
    <div class="form-field col">
        <label class="form-label">{{'finalPaperDocument_lblSearch' | translate}}</label>
        <input name="search" class="form-control" [(ngModel)]="searchValue" (input)="search()">
    </div>

    <div class="form-field col">
        <label class="form-label">{{'finalPaperDocument_lblType' | translate}}</label>
        <app-select [(ngModel)]="selectedType"
                    [options]="options.type"
                    [displayProperty]="'text'"
                    [valueProperty]="'value'"
                    (selectionChange)="filter()"
                    name="type">
        </app-select>
    </div>

    <div class="form-field col">
        <label class="form-label">{{'finalPaperDocument_lblAcademicYear' | translate}}</label>
        <app-select [(ngModel)]="selectedYear"
                    [options]="options.year"
                    [displayProperty]="'text'"
                    [valueProperty]="'value'"
                    [required]="true"
                    (selectionChange)="filter()"
                    name="year">
        </app-select>
    </div>
</div>

<app-table [rows]="items" [columns]="columns" [sticky]="'right'">
    <ng-template #rowTemplate let-row>
        <tr>
            <td>{{row.AcademicYear}}</td>
            <td>{{row.Name}}</td>
            <td>{{row.Type}}</td>
            <td>{{row.RegNumber}}</td>
            <td>
                <div class="table-actions">
                    <button type="button" class="btn btn-outline btn-icon" [ngbTooltip]="'open' | translate" (click)="open(row)">
                        <i class="fi fi-rs-document"></i>
                    </button>
                </div>
            </td>
        </tr>
    </ng-template>
</app-table>
